module.exports = __webpack_public_path__ + "static/media/Thirdwavelogo.29de0804.png";